const tooltipFormService = {
  goToPlace: 'Ir a los detalles del local',
  goToEquipment: 'Ir a los detalles del equipo'
};

export default tooltipFormService;
